import { createReducer } from "@reduxjs/toolkit";
import { createBatch, resetCreateBatch } from "./create-batch";
import type { ProcessingState } from "@redux/state/shared-types";

const initialState: ProcessingState = { processing: "idle" };

export const createBatchReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(createBatch.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(createBatch.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(createBatch.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetCreateBatch, () => {
    return initialState;
  });
});
